// 配置登录时长 12个小时
export const EXPIRE_TIME = 2 * 60 * 60 * 1000

// 上线首版只开放普通开箱；对战保留“敬请期待”入口，其余玩法隐藏并关闭路由。
export const OPENBOX_ONLY_LAUNCH = true

export const CLOSED_GAME_ROUTE_NAMES = [
  "CaseFlip",
  "Contracts",
  "CaseUpgrade",
  "Classic",
  "PizzaSet",
  "Lucky",
  "LuckyRoom",
  "LuckyRule",
  "LuckyHistory",
  "Arena",
  "ArenaRoom",
  "Roll",
  "dome",
  "Ornament",
  "OrnamentOpen",
  "OrnamentHistory",
  "OrnamentHistory2",
]
